(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hairbond-pumpkin-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-hb-landing]').forEach((root) => {

    const gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      const main = gallery.querySelector('[data-gallery-main]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      let index = 0;
      const setImage = (nextIndex) => {
        index = (nextIndex + thumbs.length) % thumbs.length;
        const thumb = thumbs[index];
        main.src = thumb.dataset.galleryThumb;
        thumbs.forEach((button) => button.classList.remove('is-active'));
        thumb.classList.add('is-active');
      };
      thumbs.forEach((thumb, thumbIndex) => thumb.addEventListener('click', () => setImage(thumbIndex)));
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => setImage(index - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => setImage(index + 1));
    }

    const offers = Array.from(root.querySelectorAll('[data-offers] .hb-offer'));
    const variantInput = root.querySelector('[data-variant-input]');
    const qtyInput = root.querySelector('[data-quantity-input]');
    offers.forEach((offer) => {
      offer.addEventListener('click', () => {
        offers.forEach((item) => item.classList.remove('is-selected'));
        offer.classList.add('is-selected');
        if (variantInput && offer.dataset.variant) variantInput.value = offer.dataset.variant;
        if (qtyInput && offer.dataset.qty) qtyInput.value = offer.dataset.qty;
      });
    });

    const ingredientSlides = Array.from(root.querySelectorAll('[data-ingredient-slide]'));
    let ingredientIndex = 0;
    const setIngredient = (nextIndex) => {
      ingredientIndex = (nextIndex + ingredientSlides.length) % ingredientSlides.length;
      ingredientSlides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === ingredientIndex));
    };
    root.querySelector('[data-ingredient-prev]')?.addEventListener('click', () => setIngredient(ingredientIndex - 1));
    root.querySelector('[data-ingredient-next]')?.addEventListener('click', () => setIngredient(ingredientIndex + 1));

    root.querySelectorAll('[data-scroll-offers]').forEach((button) => {
      button.addEventListener('click', () => root.querySelector('[id^="hb-offers"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    });

      const sticky = root.querySelector('[data-sticky-cta]');
      if (sticky) {
        window.addEventListener('scroll', () => {
          sticky.classList.toggle('is-visible', window.scrollY > 720);
        }, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
